import React, { ReactNode, createContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ApiCall from '../lib/apiCall';
import AlterarSenhaModal from './AlterarSenhaModal';

interface AuthWrapperProps {
  children: ReactNode;
}

export interface AuthState {
  user: any,
  loading: boolean
}

export const AuthContext = createContext({ user: null, loading: true });

const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
  const [auth, setAuth] = useState<AuthState>({ user: null, loading: true });
  const location = useLocation();

  useEffect(() => {
    ApiCall.get('/api/auth/me')
      .then(data => {
        setAuth({ user: data.user, loading: false });
      })
      .catch(error => {
        console.error(error)
        setAuth({ user: null, loading: false });
      });
  }, []);
  const navigate = useNavigate();


  useEffect(() => {
    if (!auth.loading && !auth.user) {
      navigate('/login?r=' + encodeURIComponent(location.pathname + location.search));
    }
  }, [auth.user, auth.loading, navigate, location.pathname, location.search]);

  if (auth.loading)
    return <div style={{ width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center' }}>
        <img src="/logo.png" alt="Logo Terachat" />
        <div style={{ fontSize: '32px', color: 'var(--tc-color-secondary)' }}>Carregando...</div>
      </div>
    </div>;

  const handleSenhaAlterada = () => {
    // Backend criou nova sessão; recarrega dados do usuário para desativar o modal
    ApiCall.get('/api/auth/me')
      .then(data => {
        setAuth({ user: data.user, loading: false });
      })
      .catch(() => {
        setAuth({ user: null, loading: false });
      });
  };

  return (
    <AuthContext.Provider value={auth}>
      {/* Troca pendente: o backend responde 403 a tudo exceto /me e /usuario/senha
          (bloquearTrocaSenhaPendente) — renderizar a página por trás só geraria
          uma leva de requisições negadas. */}
      {auth.user?.alterar_senha_proximo_login ? (
        <AlterarSenhaModal
          show
          viaToken={!!auth.user?.via_token_acesso}
          onSuccess={handleSenhaAlterada}
        />
      ) : (
        children
      )}
    </AuthContext.Provider>
  );
};

export default AuthWrapper;